export default __webpack_public_path__ + "static/media/down-sort.55c1f4a4.svg";